import Button from '@hotmart/space-lib/dist/components/button'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { COMMUNITY_EDIT_ERROR_STATE } from 'src/assets'

import styles from '../generalConfigPage/generalConfigPage.module.css'

const ErrorState = ({ refetch }) => {
  const { t } = useTranslation()

  return (
    <div className='_d-flex _flex-column' data-test='error-state'>
      <div className={styles.container}>
        <h2 className={styles.title}>{t('general', { ns: 'settings' })}</h2>

        <div className='_d-flex'>
          <img className='w-auto' src={COMMUNITY_EDIT_ERROR_STATE} alt='' loading='lazy' />
          <div className='_d-flex _flex-column _justify-content-center _ml-6'>
            <p className='_text-3 _m-0 _font-weight-light _mb-2'>
              {t('error_state.title', { ns: 'settings' })}
            </p>
            <p className='_text-2'>{t('error_state.description', { ns: 'settings' })}</p>
            <Button
              variation='primary'
              size='sm'
              role='button'
              aria-label='refetch-community-button'
              className={clsx(styles.refetchButton, '_mt-3')}
              onClick={() => refetch()}>
              {t('error_state.button', { ns: 'settings' })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorState
